import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { Label } from 'semantic-ui-react';
import { sidebarMenuTypes } from '../../cnr/reducers/SidebarReducer';
import { createInitials } from '../../common/dataAdjust';
import { formatItem, formatTypes } from '../../common/dateFormatting';
import { uniqueKey } from '../../common/keys';
import { getArrayIndex } from '../../common/sorting';
import { CalendarContext } from './Calendar';

const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const _calMonthProps = {
  labelSize: 'mini',
  labelColor: 'blue',
  formatType: formatTypes.shortestDate
}

const CalMonth = (props) => {

  const {
    currentDate,
    selectedDate,
    sbProps,
    dateKeys,
    dateKeyz,
    itemsData,
    matches,
    matches_opp,
    clickType,
    teamKey,
    crossoverOn,
    handle_onDrop
  } = props

  // calendarContext
  const calendarContext = useContext(CalendarContext)
  const { calendar_state, calendar_handlers } = calendarContext ?? {}
  const { fixedDates, selectedDates, selectedCSDates } = calendar_state ?? {}

  const _currentDate = formatItem(formatTypes.shortestDate, new Date())

  const { handleItemClick, sidebar_handlers, type: sidebarMenuType } = sbProps ?? {}
  const { handleGenericItemClick } = sidebar_handlers ?? {}
  const _selectedDate = selectedDate ? selectedDate : currentDate
  const fixed_dates = dateKeys ? dateKeys : fixedDates

  const [dragOverItem, setDragOverItem] = useState(null);

  /**
   * handles the click of a date
   * @param {array} dv 
   */
  const handleDateClick = (dv, e) => {
    if (handleItemClick) {
      handleItemClick(null, null, sidebarMenuType ? sidebarMenuType : sidebarMenuTypes.date, dv)
    } else if (handleGenericItemClick) {
      handleGenericItemClick(null, null, clickType ? clickType : sidebarMenuTypes.date, dv)
    } else if (calendar_handlers && calendar_handlers.handleCalDateSelect) {
      calendar_handlers.handleCalDateSelect(dv, e?.ctrlKey)
    } else if (props.handleClick) {
      props.handleClick(dv)
    }
  }

  const dateSpan = (d, dc, lblColor, lblTitle, matchInfo) => {
    try {
      if (dc) {
        return <React.Fragment>
          <div key={uniqueKey('cm', 'd', d)}>{d}</div>
          <Label
            key={uniqueKey('cm', 'dl', d)}
            title={lblTitle}
            color={lblColor ? lblColor : _calMonthProps.labelColor}
            size={_calMonthProps.labelSize || 'mini'}
            draggable={matchInfo?.hasMatch}
            onDragStart={(e) => {
              if (!handle_onDrop) return;
              if (!matchInfo?.hasMatch) return;
              const dt = {
                _itemKey: matchInfo?._itemKey,
                itemType: '_match',
              }
              e.dataTransfer.setData('application/json', JSON.stringify(dt));
            }}
            style={{ cursor: 'grab' }}
          >{dc}
          </Label>
        </React.Fragment>
      } else {
        return <React.Fragment >
          <div key={uniqueKey('cm', 'd1', d)}>{d}</div>
          <div key={uniqueKey('cm', 'd2', d)}></div>
        </React.Fragment>
      }
    } catch (error) {
      return <div key={uniqueKey('cm', 'd1', d)}>{'xxx'}</div>
    }
  }

  const getMatchInfo = (_thisDate) => {

    let info = {
      _opp: null,
      lblTitle: null,
      lblColor: null,
      hasMatch: false,
      hasOppMatch: false,
      noDrop: false,
      noDropOpp: false,
    };

    const processMatch = (match, oppMatch, initialsLength = 3) => {

      const { home, away, _itemKey } = match ?? {};

      const hasOppMatch = oppMatch ? true : false

      if (teamKey === home?.id && away?.name) {
        return {
          _opp: createInitials(away.name, initialsLength),
          lblTitle: `vs. ${away.name}`,
          lblColor: 'teal',
          hasMatch: true,
          hasOppMatch,
          noDrop: true,
          _itemKey
        };
      }

      if (teamKey === away?.id && home?.name) {
        return {
          _opp: createInitials(home.name, initialsLength),
          lblTitle: `@ ${home.name}`,
          lblColor: 'orange',
          hasMatch: true,
          hasOppMatch,
          noDrop: true,
          _itemKey
        };
      }


      return hasOppMatch ? { hasOppMatch, noDropOpp: true } : null;

    };

    const scheduledMatch = _.find(matches, { startDate: _thisDate });
    const oppMatch = _.find(matches_opp, { startDate: _thisDate })

    if (scheduledMatch || oppMatch) {
      return processMatch(scheduledMatch, oppMatch);
    }

    const scoreItem = _.find(itemsData, { matchDate: _thisDate });

    if (scoreItem?.matches?.length === 1) {
      return processMatch(scoreItem.matches[0], oppMatch, undefined);
    }

    return info;
  };

  const calDates = () => {

    const cds = []

    const _firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    let _firstDayOfMonth = _firstDateOfMonth.getDay() + 1

    const months = 1
    const weeks = 6
    const days = 7
    let dd = 0
    let go = false
    let month = 0

    for (var wd = 1; wd <= days; wd++) {
      cds.push(<div key={uniqueKey('cm', 'wd', wd)} className='dow'>{dateSpan(weekday[wd - 1])}</div>)
    }

    // loop the months
    for (var m = 1; m <= months; m++) {
      // loop the weeks
      for (var w = 1; w <= weeks; w++) {
        const ow = []
        let owdn = 0
        // loop the days
        for (var d = 1; d <= days; d++) {
          if (d >= _firstDayOfMonth && !go) {
            go = true
            month = currentDate.getMonth()
          }
          if (go) {
            dd++

            const _thisDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), dd)

            if (month === _thisDayOfMonth.getMonth()) {

              const _selDate = formatItem(_calMonthProps.formatType, _selectedDate)
              const _thisDate = formatItem(_calMonthProps.formatType, _thisDayOfMonth)
              const _dateCount = dateKeyz && dateKeyz[_thisDate]

              const matchInfo = getMatchInfo(_thisDate);

              let allowDateDrop = true;
              let sel;
              let selAlt;
              let dc;
              let cn;

              if (!fixed_dates) {
                try {
                  if (selectedDates && selectedDates.length > 0) {
                    sel = selectedDates.includes(_thisDate)
                  } else {
                    sel = (_selDate === _thisDate)
                  }
                  if (selectedCSDates && selectedCSDates.length > 0) {
                    selAlt = selectedCSDates.includes(_thisDate)
                  }
                } catch (error) {
                  console.error(error)
                }
              }

              if (fixed_dates && (getArrayIndex(fixed_dates, _thisDate) < 0)) {
                cn = 'non-sel'
              } else {
                dc = _dateCount
                if (matchInfo?._opp) { dc = matchInfo._opp }
                if (sel) {
                  cn = dc ? 'norm-count' : 'norm'
                  cn += ' sel'
                  if (crossoverOn) { cn += ' co' }
                  if (_currentDate === _thisDate) { cn += ' current-date' }
                } else if (selAlt) {
                  cn = dc ? 'norm-count' : 'norm'
                  cn += ' sel alt'
                  if (_currentDate === _thisDate) { cn += ' current-date' }
                } else {
                  cn = dc ? 'norm-count' : 'norm'
                  if (dateKeys) { cn += ' dk' }
                  cn += ' non-sel'
                  if (_currentDate === _thisDate) { cn += ' current-date' }
                }

                if (matchInfo?.noDrop) {
                  allowDateDrop = false
                  cn += ' no-drop'
                }

                if (matchInfo?.noDropOpp) {
                  allowDateDrop = false
                  cn += ' no-drop-opp'
                }
              }

              // THE ONLY DIV
              ow.push(<div
                key={uniqueKey('cm', m, w, d)}
                className={cn}
                // ON DROP!!!

                onDrop={(e) => {
                  if (!handle_onDrop) return;
                  e.preventDefault();
                  const isAway = e.shiftKey
                  const dt = JSON.parse(e.dataTransfer.getData('application/json'));
                  !matchInfo?.hasMatch && handle_onDrop && handle_onDrop({
                    itemType: dt?.itemType,
                    _itemKey: dt?._itemKey,
                    date: _thisDate,
                    isAway
                  })
                  setDragOverItem()
                }}

                onDragOver={(e) => {
                  if (!handle_onDrop) return;
                  if (matchInfo?.noDrop || matchInfo?.noDropOpp) {
                    e.dataTransfer.dropEffect = 'none';
                    return;
                  }
                  e.preventDefault();
                  e.dataTransfer.dropEffect = 'move';
                  setDragOverItem(_thisDate)
                }}

                onDragLeave={() => {
                  setDragOverItem(null);
                }}

                onClick={e => handleDateClick(_thisDate, e)}

                style={{
                  backgroundColor: allowDateDrop && (dragOverItem === _thisDate) ? 'var(--off-black-7) !important' : null,
                  border: allowDateDrop && (dragOverItem === _thisDate) ? '2px solid var(--sem-green)' : null
                }}
              >
                {dateSpan(dd, dc, matchInfo?.lblColor, matchInfo?.lblTitle, matchInfo)}</div>
              )
            } else {
              ow.push(<div
                key={uniqueKey('cm', m, w, d)}
                className='nd'
                onDragOver={(e) => {
                  if (!handle_onDrop) return;
                  e.dataTransfer.dropEffect = 'none';
                  return;
                }}
              >{'--'}</div>)
              owdn++
            }
          } else {
            ow.push(<div key={uniqueKey('cm', m, w, d)} className='nd'>{'--'}</div>)
            owdn++
          }
        }
        if (owdn < 7) {
          cds.push([...ow])
        }
      }
    }
    return cds
  }

  return <div key={uniqueKey('cm')} className="calendar-container">
    {calDates()}
  </div>
}

export default CalMonth